import React, { ReactElement } from "react";

import { Container, LogoContainerMenu } from "./styles";

import * as Logos from "~/components/icons/Logo";
import Spacer, { Axis } from "~/components/Spacer";

type Props = {
  isMenuOpen: boolean;
  items: ReactElement[];
};

export default function Menu({ items, isMenuOpen }: Props) {
  return (
    <Container data-testid="menu" openMenu={isMenuOpen}>
      <>
        <LogoContainerMenu inverted={true}>
          <Logos.Logo style={{ width: "100%", height: "100%" }} />
        </LogoContainerMenu>
        <Spacer axis={Axis.VERTICAL} size={40} />
        {items.map((item, index) => (
          <span key={index}>{item}</span>
        ))}
      </>
    </Container>
  );
}
